import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ConfirmButton = styled(Button)`
    //margin-left: 10px;
    width: fit-content;
    margin: ${({ margin }) => (margin || '')};
`;
ConfirmButton.displayName = 'ConfirmButton';

export const CancelButton = styled(BaseCancelButton)`
`;
CancelButton.displayName = 'CancelButton';

export const ButtonContainer = styled.div`
align-self: flex-end;
margin-bottom: 16px;
`;
